import { TakePosition } from "../../app/slices/EnvironmentSlice";

/**
 * Take locations on the layers the user has switched on. No selection means every
 * layer; locations without a layer belong to "default". The current take's own
 * location is always kept, whatever its layer.
 */
export function filterTakePositionsByLayers(
  takePositions: TakePosition[],
  visibleLayerIds: string[],
  currentTakeLocationLayer?: string
): TakePosition[] {
  const layerIds =
    currentTakeLocationLayer && !visibleLayerIds.includes(currentTakeLocationLayer)
      ? [...visibleLayerIds, currentTakeLocationLayer]
      : visibleLayerIds;
  if (layerIds.length === 0) return takePositions;

  return takePositions.filter((point) =>
    layerIds.includes(point.layer || "default")
  );
}

/**
 * The take location a Set Camera's camera belongs to. `takeLocationId` is the take
 * position's id, or the situation's id when that position runs a situation in this take.
 * Falls back to the take's own location.
 */
export function resolveCameraTakeLocation(
  takePositions: TakePosition[],
  takeLocationId: string | undefined,
  take: { interactionPointId?: string; situations?: Record<string, string> } | undefined
): TakePosition | undefined {
  const byId = (id?: string) => (id ? takePositions.find((p) => p.id === id) : undefined);
  const situationPositionId = Object.entries(take?.situations ?? {}).find(
    ([, situationId]) => situationId === takeLocationId
  )?.[0];
  return byId(takeLocationId) ?? byId(situationPositionId) ?? byId(take?.interactionPointId);
}
